/**
 * Catch-all 404 page.
 *
 * Without a `path: "*"` route, React Router renders its default developer
 * error boundary ("Unexpected Application Error!") for any unmatched URL.
 *
 * The route keeps unknown SPA URLs from showing React Router's default
 * developer-oriented error boundary.
 */
import { Link } from "react-router";
import styles from "./not-found.module.css";

export default function NotFound() {
  return (
    <main className={styles.page}>
      <p className={styles.code}>404</p>
      <h1 className={styles.title}>Page not found</h1>
      <p className={styles.message}>That page doesn’t exist.</p>
      <Link to="/events" className={styles.back}>
        Back to Events
      </Link>
    </main>
  );
}
